"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcTable = void 0;
var ui_1 = require("@aperza/ui");
var util_1 = require("@aperza/util");
var react_1 = __importStar(require("react"));
var Table_1 = __importDefault(require("react-bootstrap/Table"));
var react_router_dom_1 = require("react-router-dom");
var AcButton_1 = require("../button/AcButton");
var AcLoadingBlock_1 = require("../layout/AcLoadingBlock");
var AcConditionalWrapper_1 = require("../util/AcConditionalWrapper");
var FaIcon_1 = require("../util/FaIcon");
var AcTable_module_scss_1 = __importDefault(require("./AcTable.module.scss"));
var AcTableActionCell_1 = require("./AcTableActionCell");
var AcTableContactCell_1 = require("./AcTableContactCell");
var AcTableContext_1 = require("./AcTableContext");
var AcTableHeader_1 = require("./AcTableHeader");
var AcTableNoData_1 = __importDefault(require("./AcTableNoData"));
var AcTableRow_1 = require("./AcTableRow");
var AcTableSelectorCell_1 = require("./AcTableSelectorCell");
var AcTableSelectorHeaderCell_1 = require("./AcTableSelectorHeaderCell");
var UseAcTableData_1 = require("./UseAcTableData");
/**
 * Generic
 * T - type of the item data
 * F - type of the function context
 */
var AcTable = function (props) {
    var loading = props.loading, pageSizes = props.pageSizes, size = props.size, sorts = props.sorts, enableExpandAll = props.enableExpandAll, expandAllName = props.expandAllName, _a = props.expandableRow, expandableRow = _a === void 0 ? true : _a, topActionBar = props.topActionBar, onSort = props.onSort, onRowClick = props.onRowClick, onRowExpand = props.onRowExpand, onRowCollapse = props.onRowCollapse, onSelectPageSize = props.onSelectPageSize, highlight = props.highlight, hoverable = props.hoverable, enableCustomHeaderSelector = props.enableCustomHeaderSelector, enableAllRecordsSelector = props.enableAllRecordsSelector, _b = props.functionContext, functionContext = _b === void 0 ? {} : _b, whenNoData = props.whenNoData, topActionBarWhenNoData = props.topActionBarWhenNoData, hideHeader = props.hideHeader, columns = props.columns, data = props.data, activeData = props.activeData, selectedRowCount = props.selectedRowCount, rowClassName = props.rowClassName, rowGap = props.rowGap, expandRowWithoutTrTag = props.expandRowWithoutTrTag, renderRowsOnly = props.renderRowsOnly;
    var _c = UseAcTableData_1.useAcTableData({
        columns: columns,
        data: data,
        functionContext: functionContext,
        highlight: highlight,
    }), acTableColumns = _c.acTableColumns, acTableItems = _c.acTableItems, setData = _c.setData, setColumns = _c.setColumns;
    var acTableContextMethods = AcTableContext_1.useAcTableContext();
    var _d = __read(react_1.useState(new Map()), 2), rowIndexAndRefMap = _d[0], setRowIndexAndRefMap = _d[1];
    var _e = __read(react_1.useState(0), 2), updateRowHeights = _e[0], setUpdateRowHeights = _e[1];
    react_1.useEffect(function () {
        if (rowIndexAndRefMap.size > 0) {
            // separate effect, the table needs to be rendered first to get the height.
            setRowIndexAndRefMap(new Map(rowIndexAndRefMap));
        }
    }, [updateRowHeights]);
    // after resize is rendered
    ui_1.useWindowResize(function () {
        setRowIndexAndRefMap(new Map());
        setUpdateRowHeights(function (_updateRowHeights) { return _updateRowHeights + 1; });
    }, 100);
    react_1.useEffect(function () {
        // also update columns when updating on data
        setColumns(columns);
        setData(data || []);
        acTableContextMethods.setAcTableColumns(columns);
        setRowIndexAndRefMap(new Map());
        setUpdateRowHeights(function (_updateRowHeights) { return _updateRowHeights + 1; });
    }, [data]);
    var history = react_router_dom_1.useHistory();
    var createCell = function (acTableColumn, index, acTableItem) {
        if (acTableColumn.selector) {
            return (react_1.default.createElement(AcTableSelectorCell_1.AcTableSelectorCell, { key: index, item: acTableItem, enableSelector: acTableColumn.enableSelector, data: acTableItem.data, functionContext: functionContext }));
        }
        if (acTableColumn.actions) {
            return (react_1.default.createElement(AcTableActionCell_1.AcTableActionCell, { key: index, actions: acTableColumn.buildAction(acTableItem.data, functionContext), data: acTableItem.data, functionContext: functionContext }));
        }
        if (acTableColumn.contacts) {
            return react_1.default.createElement(AcTableContactCell_1.AcTableContactCell, { key: index, contacts: acTableColumn.contacts });
        }
        if (acTableColumn.data) {
            var value = acTableColumn.buildValue(acTableItem.data, functionContext);
            var linkWrapper = function (el) { return react_1.default.createElement(react_1.default.Fragment, null, el); };
            if (acTableColumn.hasPath()) {
                var path_1 = acTableColumn.buildPath(acTableItem.data);
                var onClick_1 = function () {
                    history.push(path_1);
                };
                linkWrapper = function (el) { return (react_1.default.createElement("a", { href: "#", onClick: function () {
                        onClick_1();
                        return false;
                    } }, el)); };
            }
            return react_1.default.createElement(react_1.default.Fragment, null, linkWrapper(value));
        }
        return null;
    };
    var rows = acTableItems.map(function (acTableItem, rowIndex) {
        var isLastRow = rowIndex === acTableItems.length - 1;
        var rowRef = rowIndexAndRefMap.get(rowIndex)
            ? rowIndexAndRefMap.get(rowIndex)
            : rowIndexAndRefMap.set(rowIndex, react_1.default.createRef()).get(rowIndex);
        var hasAtLeastOneFrozenColumnConfig = acTableColumns.some(function (column) { return column.freezeColumn; });
        var cols = acTableColumns
            .filter(function (acTableColumn) { return acTableColumn.shouldDisplay(functionContext); })
            .map(function (acTableColumn, index) {
            var _a;
            if (acTableColumn.shouldDisplay(functionContext)) {
                var cell = createCell(acTableColumn, rowIndex + index, acTableItem);
                var cellWidth = 'auto';
                if (acTableColumn.actions) {
                    cellWidth = acTableColumn.buildAction(acTableItem.data, functionContext).length * 52 + 20 + "px";
                }
                if (acTableColumn.width) {
                    cellWidth = acTableColumn.width + "px";
                }
                var colSpan = 1;
                if (acTableColumn.colSpan) {
                    colSpan = acTableColumn.buildColSpan(functionContext);
                }
                var rowComputedStyle = hasAtLeastOneFrozenColumnConfig
                    ? {
                        width: cellWidth,
                        maxWidth: cellWidth,
                        height: (_a = rowRef === null || rowRef === void 0 ? void 0 : rowRef.current) === null || _a === void 0 ? void 0 : _a.getRowHeight(),
                    }
                    : {
                        width: cellWidth,
                        maxWidth: cellWidth,
                    };
                return (react_1.default.createElement("td", { key: "" + index, "data-freeze-column": acTableColumn.freezeColumn, className: acTableColumn.buildClassname(acTableItem.data, functionContext) + " " + AcTable_module_scss_1.default.tableCell + " " + (acTableColumn.freezeColumn && AcTable_module_scss_1.default.freezeColumn), colSpan: colSpan, style: rowComputedStyle }, cell));
            }
            return undefined;
        });
        var isExpandableRow = expandableRow;
        if (typeof expandableRow === 'function') {
            isExpandableRow = expandableRow(acTableItem.data);
        }
        return (react_1.default.createElement(AcTableRow_1.AcTableRow, { ref: rowRef, key: "" + rowIndex, data: acTableItem.data, activeData: activeData, highlight: highlight, functionContext: functionContext, onRowClick: onRowClick, onRowExpand: onRowExpand, onRowCollapse: onRowCollapse, rowClassName: rowClassName, rowGap: !isLastRow ? rowGap : undefined, expandRowWithoutTrTag: expandRowWithoutTrTag, isExpandableRow: isExpandableRow }, cols));
    });
    var hasSelector = acTableColumns &&
        acTableColumns.find(function (acTableColumn) { return acTableColumn.selector && acTableColumn.shouldDisplay(functionContext); });
    if (renderRowsOnly) {
        return react_1.default.createElement(react_1.default.Fragment, null, rows);
    }
    // identify how many columns need to be frozen
    var totalPixelsOfFrozenColumns = acTableColumns
        .filter(function (c) { return c.freezeColumn; })
        .map(function (c) { return util_1.NumberUtil.parseNumber(c.width); })
        .reduce(function (a, c) { return a + c; }, 0);
    var hasFrozenColumns = totalPixelsOfFrozenColumns > 0;
    // keep existing class to not affect existing tables, only apply new class when frozen columns
    var tableWrapperClass = hasFrozenColumns && !loading ? AcTable_module_scss_1.default.tableWrapperWithFreezeColumn : AcTable_module_scss_1.default.tableWrapper;
    var frozenColumnWidth = hasFrozenColumns
        ? { width: "calc(100% - " + totalPixelsOfFrozenColumns + "px)" }
        : {};
    return (react_1.default.createElement("div", { id: "AcTableDiv", className: "table-responsive " + tableWrapperClass, style: frozenColumnWidth },
        !loading && (!rows || rows.length === 0) && (react_1.default.createElement(react_1.default.Fragment, null,
            topActionBarWhenNoData && (react_1.default.createElement(AcConditionalWrapper_1.AcConditionalWrapper, { ifHTMLChildren: true },
                react_1.default.createElement("div", { className: "d-flex flex-row flex-grow-1 align-items-start" }, topActionBarWhenNoData))),
            react_1.default.createElement(AcTableNoData_1.default, null, whenNoData || react_1.default.createElement("p", { className: "fs-18 font-weight-bold" }, "\u8868\u793A\u3067\u304D\u308B\u30C7\u30FC\u30BF\u304C\u3042\u308A\u307E\u305B\u3093")))),
        rows && rows.length > 0 && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(AcConditionalWrapper_1.AcConditionalWrapper, { ifHTMLChildren: true },
                react_1.default.createElement("div", { className: "mb-3 py-1 d-flex flex-row" },
                    hasSelector && (react_1.default.createElement(AcTableSelectorHeaderCell_1.AcTableSelectorHeaderCell, { enableCustomHeaderSelector: enableCustomHeaderSelector, enableAllRecordsSelector: enableAllRecordsSelector, selectedRowCount: selectedRowCount })),
                    topActionBar && (react_1.default.createElement("div", { className: "d-flex flex-row flex-grow-1 align-items-start" }, topActionBar)),
                    enableExpandAll && (react_1.default.createElement(AcButton_1.AcButton, { variant: "sub4", className: "mr-3", size: "sm", onClick: function () { return acTableContextMethods === null || acTableContextMethods === void 0 ? void 0 : acTableContextMethods.toggleExpandAll(); } },
                        react_1.default.createElement(FaIcon_1.FaIcon, { icon: (acTableContextMethods === null || acTableContextMethods === void 0 ? void 0 : acTableContextMethods.isExpandAll)
                                ? 'fas fa-chevron-double-up'
                                : 'fas fa-chevron-double-down', className: "mr-1", fixedWidth: true }),
                        (acTableContextMethods === null || acTableContextMethods === void 0 ? void 0 : acTableContextMethods.isExpandAll)
                            ? expandAllName + "\u3092\u3059\u3079\u3066\u9589\u3058\u308B"
                            : expandAllName + "\u3092\u3059\u3079\u3066\u958B\u304F")))),
            react_1.default.createElement(Table_1.default, { hover: hoverable, className: AcTable_module_scss_1.default.table },
                !hideHeader && (react_1.default.createElement(AcTableHeader_1.AcTableHeader, { columns: acTableColumns, functionContext: functionContext, sorts: sorts, onSort: onSort, pageSizes: pageSizes, pageSize: size, onSelectPageSize: onSelectPageSize })),
                react_1.default.createElement("tbody", null, rows)))),
        loading && react_1.default.createElement(AcLoadingBlock_1.AcLoadingBlock, null)));
};
exports.AcTable = AcTable;
exports.AcTable.displayName = 'AcTable';
exports.AcTable.defaultProps = {
    columns: [],
    data: [],
};
//# sourceMappingURL=AcTable.js.map